module.exports = __webpack_public_path__ + "media/images/person-20b42d391b8ab3145f95e44b53d12209.png";